import Card from "@pathwright/ui/src/components/card/Card"
import { FeatureAction, FeatureKey } from "../../api/generated"
import EnterpriseSSOFeatureBlock from "../../feature/auth/EnterpriseSSOFeatureBlock"
import PathwrightSignInFeatureBlock from "../../feature/auth/PathwrightSignInFeatureBlock"
import FeatureBlockList, {
  Container
} from "../../feature/block/FeatureBlockList"

const ManageAccountFeatures = ({ card }) => {
  return (
    <Card card={card} title="Configure Sign-in Options">
      <Container>
        <PathwrightSignInFeatureBlock />
      </Container>
      <FeatureBlockList
        key={FeatureAction.AuthLogin}
        featureAction={FeatureAction.AuthLogin}
        featureKeys={[
          FeatureKey.AuthLoginOptionGlobalSsoApple,
          FeatureKey.AuthLoginOptionGlobalSsoGoogle
        ]}
        showTagFeatureBlock={false}
      />
      <Container>
        <EnterpriseSSOFeatureBlock />
      </Container>
    </Card>
  )
}

ManageAccountFeatures.displayName = "ManageAccountFeatures"

export default ManageAccountFeatures
